import {useCallback, useContext, useEffect, useRef} from 'react';

import {
    useAspectsToneDistribution,
    useAspectsToneDynamics,
    useReviewAnalyticsAspects,
    useReviewsCountByAspects,
} from '../../../../../../service/reivew-analysis/review-aspects/review-aspects-hook';
import {KeywordsAndTopicsPageContext} from '../keywords-and-topics-page-context';

import {AspectsTable} from './aspects-table/aspects-table';
import {AspectsToneDistributionChart} from './aspects-tone-distribution/aspects-tone-distribution-chart';
import {AspectsToneDynamicsCharts} from './aspects-tone-dynamics/aspects-tone-dynamics-charts';
import {AspectsToneRadar} from './reviews-count-by-aspects/aspects-tone-radar';

export function AspectsTab(): JSX.Element {
    const {onIsFormInProgressChange} = useContext(KeywordsAndTopicsPageContext);

    const scrollRef = useRef<HTMLDivElement>(null);

    const scrollToTable = useCallback(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }, []);

    const reviewAnalyticsAspects = useReviewAnalyticsAspects({
        onPageChange: scrollToTable,
    });

    const aspectsToneDynamics = useAspectsToneDynamics();

    const aspectsToneDistribution = useAspectsToneDistribution();

    const reviewsCountByAspects = useReviewsCountByAspects();

    useEffect(() => {
        const isLoading =
            reviewsCountByAspects.isLoading ||
            reviewAnalyticsAspects.isLoading ||
            aspectsToneDynamics.isLoading ||
            aspectsToneDistribution.isLoading;

        onIsFormInProgressChange(isLoading);
    }, [
        aspectsToneDistribution.isLoading,
        aspectsToneDynamics.isLoading,
        onIsFormInProgressChange,
        reviewAnalyticsAspects.isLoading,
        reviewsCountByAspects.isLoading,
    ]);

    return (
        <>
            <AspectsToneDynamicsCharts aspectsToneDynamics={aspectsToneDynamics} />

            <div ref={scrollRef}>
                <AspectsTable reviewAnalyticsAspects={reviewAnalyticsAspects} />
            </div>

            <AspectsToneDistributionChart aspectsToneDistribution={aspectsToneDistribution} />

            <AspectsToneRadar reviewsCountByAspects={reviewsCountByAspects} />
        </>
    );
}
